<template>
  <div class="company-navigation-wrapper">
    <ul class="company-navigation">
      <li>
        <router-link to="/spartan/bio" class="section-link">bio</router-link>
      </li>
      <li>
        <router-link to="/spartan/work-order" class="section-link"
          >work order</router-link
        >
      </li>
      <li>
        <router-link to="/spartan/contact" class="section-link"
          >contact</router-link
        >
      </li>
    </ul>
    <transition name="slide-fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
  name: "SpartanNavigation",
   watch: {
      '$route':{
        handler: (to) => {
          document.title = to.meta.title || 'Spartan Builders'
        },
         immediate: true
      }
    } 
};
</script>

<style lang="scss" scoped>
@import "./src/stylesheets/base/_variables.scss";




.company-navigation {
  display: flex;
  margin-top: 1em;
  padding: 1em 0 0 0;
  list-style: none;
  text-transform: uppercase;

  @media screen and (max-width: $medium-bp) {
    justify-content: center;
    position: sticky;
    top: 0em;
  }

  @media screen and (min-width: $medium-bp+0.1) {
    text-align: right;
    display: flex;
    flex-direction: column;
    position: sticky;
    top: 0em;
    justify-content: center;
    border-right: 1px solid #000;
  }

  li {
    margin-left: 1em;
    margin-right: 1em;
  }
}
</style>
